import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, Checkbox, IconButton, Spinner } from "@material-tailwind/react";
import Zoom from 'react-medium-image-zoom';
import { Pagination, SearchAndAddBtn, THead } from '../../Components';
import { get_subscription_data } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import moment from 'moment'
import SubscriptionModal from '../../Components/Modals/SubscriptionModal';
import { TiClipboard } from 'react-icons/ti';
import { toast } from 'react-toastify';
import { RiDeleteBinLine } from 'react-icons/ri';



export const Subscription = ({ title }) => {
  const { permissions, tokenType, setDeleteUpdateTag, deleteUpdateItem, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, isAscending, sortData, setDeleteUpdateItem, confirmationModalShow, setConfirmationModalShow, setDeleteUpdateYes } = useContext(NewContext);
  const simpleFields = [
    { name: "Preview", },
    { name: "name", sortable: true, field: 'name' },
    { name: "Created At", sortable: true, field: 'createdAt' },
  ];
  const [pagePermissions, setPagePermissions] = useState({
    CU: true,
    R: true,
    D: true
  });
  const totalFields = simpleFields.length + 2;

  const getSubscriptionData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
    setIsLoading(true);
    try {
      const getSubscription = await get_subscription_data(_currentPage, perPage, search, filterDropdown, sortName, sortType);
      if (getSubscription) {
        const { status, data, currentPage, perPage, totalPage } = getSubscription;
        if (status) {
          setCurrentPageData(data);
          setCurrentPage(currentPage);
          setPerPage(perPage);
          setTotalPage(totalPage || 1);
        } else {
          setCurrentPageData([]);
        }
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }
  const copyText = async (data) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(data);
        toast.success("Data Copied Successfully");
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = data;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        toast.success("Data Copied Successfully");
      }
    } catch (error) {
      toast.error("Error copying text to clipboard");
    }
  };


  useEffect(() => {
    getSubscriptionData(currentPage, sortData, isAscending);
    setDeleteUpdateTag("");
  }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, pagePermissions, sortData, isAscending]);

  useEffect(() => {
    if (tokenType === 'ldap') {
      const update = permissions?.subPermissions?.find((route) => route.name === 'Subscription');
      setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
    }
  }, [tokenType, permissions])

  useEffect(() => {
  }, [pagePermissions])


  useEffect(() => {
    document.title = title;
  }, [title])

  return (
    <>
      <SearchAndAddBtn title={`Subscription`} addBtn={pagePermissions?.CU} deleteUpdateTag='all-delete-subscription' resetFilterBtn={false} />
      <Card className="overflow-hidden w-full rounded-md shadow-none">
        <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
          <table className="w-full min-w-max table-auto text-left ">
            <THead simpleFields={simpleFields} isSelectAll={false} />
            <tbody>
              {
                isLoading ?
                  <tr>
                    <td colSpan={totalFields} className='py-12'>
                      <div className="flex justify-center items-center">
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                  : currentPageData?.length === 0 ?
                    <tr>
                      <td colSpan={totalFields} className='py-12 bg-gray-200'>
                        <div className="flex justify-center items-center">
                          No Data Found
                        </div>
                      </td>
                    </tr>
                    : currentPageData?.map((_ele, i) => {
                      const isLast = i === currentPageData?.length - 1;
                      const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                      return (
                        <tr key={i} className='border-b border-blue-gray-50'>
                          <td className={`${classes}`}>
                            <div className='flex imgTd relative'>
                              <img src={_ele.url || `../../../assets/images/no-image.png`} alt={_ele.name} className='mr-0 h-[55px] rounded-lg block absolute' />
                              <Zoom>
                                <img src={_ele.url || `../../../assets/images/no-image.png`} alt={_ele.name} className='mr-0 h-[55px] rounded-lg block' />
                              </Zoom>
                            </div>
                          </td>
                          <td className={classes}>
                            <div className="flex items-center">
                              <span className={`font-normal text-[17px] ${!_ele.name && `text-gray-500`}`}>{_ele.name || `None`}</span>
                            </div>
                          </td>
                          <td className={classes}>
                            <div className="flex items-center">
                              <span className={`font-normal text-[17px] ${!_ele.createdAt && `text-gray-500`}`}>{moment(_ele?.createdAt).format('DD/MM/YYYY, hh:mm A')}</span>
                            </div>
                          </td>
                          <td className={classes}>
                            <div className="flex items-center gap-2">
                              <IconButton className='bg-[#EAEDF3] text-[#000000] text-[21px] shadow-none hover:shadow-none' onClick={() => copyText(_ele?.url)}>
                                <TiClipboard />
                              </IconButton>
                              <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-subscription"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                <RiDeleteBinLine />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      );
                    })
              }
            </tbody>
          </table>
        </CardBody>
      </Card>
      {
        totalPage > 1 &&
        <Pagination currentPage={currentPage} totalPage={totalPage} getData={getSubscriptionData} />
      }
      <SubscriptionModal />
    </>
  )
}
Subscription.defaultProps = {
  title: "Message | Subscription"
};



export default Subscription
